import { render, staticRenderFns } from "./RupturasDashboard.vue?vue&type=template&id=2bd12055&scoped=true"
import script from "./RupturasDashboard.vue?vue&type=script&lang=js"
export * from "./RupturasDashboard.vue?vue&type=script&lang=js"
import style0 from "./RupturasDashboard.vue?vue&type=style&index=0&id=2bd12055&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd12055",
  null
  
)

export default component.exports